export function initialize(appInstance) {
  // Load service to watch routes
  appInstance.lookup('service:breadcrumb');
}

export default {
  initialize,
};
